import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import MailIcon1 from "../../../assets/images/webLogin/mail1.png";
import MailIcon2 from "../../../assets/images/webLogin/mail2.png";
import MailIcon3 from "../../../assets/images/webLogin/mail3.png";
import MobileIcon1 from "../../../assets/images/webLogin/mobile1.png";
import MobileIcon2 from "../../../assets/images/webLogin/mobile2.png";
import MobileIcon3 from "../../../assets/images/webLogin/mobile3.png";
import cn from "../../../utils/cn";

const icons = {
  mail: [MailIcon1, MailIcon2, MailIcon3],
  phoneNumber: [MobileIcon1, MobileIcon2, MobileIcon3],
};

export default function AccountInput({
  accountType,
  setInputValue,
  errorMessage,
  isFirstFocused,
  setIsFirstFocused,
}: {
  accountType: "mail" | "phoneNumber";
  setInputValue: Dispatch<SetStateAction<string>>;
  errorMessage: string;
  isFirstFocused: boolean;
  setIsFirstFocused: Dispatch<SetStateAction<boolean>>;
}) {
  const { t } = useTranslation();

  const [isFocused, setIsFocused] = useState(false);

  const [defaultIcon, focusedIcon, errorIcon] = icons[accountType];
  const icon = errorMessage ? errorIcon : isFocused ? focusedIcon : defaultIcon;
  const borderColor = errorMessage
    ? "border-red0"
    : isFocused
      ? "border-pink2"
      : "border-greyType102";
  const caretColor = errorMessage
    ? "caret-red0"
    : isFocused
      ? "caret-orange"
      : "caret-grey4";
  const placeholderText = isFocused || errorMessage ? "" : t("accountPlaceholder");

  const handleInputChange = (event: any) => {
    setInputValue(event.target.value);
  };

  return (
    <div className="relative w-full">
      <img src={icon} alt={accountType} className="absolute left-3 top-3 size-6" />

      <input
        type={accountType === "mail" ? "email" : "text"}
        className={cn(
          "h-12 w-full flex-1 rounded-full border border-solid text-center font-normal text-black8 focus:outline-none focus:ring-0",
          borderColor,
          caretColor,
        )}
        onFocus={() => {
          if (!isFirstFocused) setIsFirstFocused(true);

          setIsFocused(true);
        }}
        onBlur={() => setIsFocused(false)}
        onChange={handleInputChange}
        placeholder={placeholderText}
      />
    </div>
  );
}
